// "How to play Dominoes" — the rules exactly as the games function plays them
// (supabase/functions/games/dominoes.ts). Shared by the on-screen guide and
// the VR rules panel.

/** Video walkthrough of block (partners/no boneyard) and draw (boneyard) dominoes. Verified 2026-10-11. */
export const DOMINOES_TUTORIAL_URL = 'https://www.youtube.com/watch?v=xYeunMBhVq0';
export const DOMINOES_TUTORIAL_TITLE = 'How To Play Dominoes | block, draw, muggins — Riffle Shuffle & Roll';

export const DOMINOES_RULES: { title: string; lines: string[] }[] = [
  {
    title: 'Players & tiles',
    lines: [
      'A double-six set: 28 tiles, 7 each.',
      'Four players play partners — North & South vs East & West, partners across the table. All 28 tiles are dealt.',
      'Two players play head-to-head: the other 14 tiles stay face down in the boneyard. (Three players: everyone for themselves, with a boneyard.)',
    ],
  },
  {
    title: 'Leading',
    lines: [
      'First hand: whoever holds the double-six sets it. (Two or three players: if it\'s in the boneyard, the highest double held leads; no doubles at all → the heaviest tile.)',
      'Every hand after that: the winner of the last hand leads any tile they like.',
    ],
  },
  {
    title: 'Your turn',
    lines: [
      'Play one tile that matches an open end of the line — a 6-4 goes on a 6 end and leaves a 4 showing. Doubles lie crosswise.',
      'If a tile fits both ends, tap the tile, then tap Left end or Right end.',
      'Can\'t play? Four players: pass. Two players: draw from the boneyard until you can play; when it\'s empty, pass.',
      'Turns go clockwise: North, East, South, West.',
    ],
  },
  {
    title: 'Ending a hand',
    lines: [
      'Domino: the first player to play their last tile wins the hand for their side.',
      'Block: if nobody can play (and the boneyard is empty), the player with the fewest pips left wins it. A tie between the two sides scores nothing.',
    ],
  },
  {
    title: 'Scoring',
    lines: [
      'The winning side scores every pip left in the opponents\' hands, rounded to the nearest 5 (12 → 10, 13 → 15).',
      'First side to the target wins the game — 100 by default; choose 150 or 200 in the lobby.',
    ],
  },
];
